import React, { useEffect, useState } from "react";
import LeaveProcessService from "../services/LeaveProcessService";
import { toast } from "react-toastify";
import { useLoading } from "../Utils/LoadingContext";
import LeaveModal from "../components/modals/LeaveModel";
import ARModal from "../components/modals/ARModal";
import ODModal from "../components/modals/ODModal";

export default function LeaveStatus() {

    // const { setLoading } = useLoading();
    const { setLoading, loading } = useLoading();
    const [leaves, setLeaves] = useState([]);
    const [statusFilter, setStatusFilter] = useState("");
    const [selectedItem, setSelectedItem] = useState(null);
    const [modalType, setModalType] = useState("");

    const [activeTab, setActiveTab] = useState("");

    // ✅ COUNT STATES
    const [leaveCount, setLeaveCount] = useState(0);
    const [arCount, setArCount] = useState(0);
    const [odCount, setOdCount] = useState(0);

    const employeeCode = localStorage.getItem("empcode");

    useEffect(() => {
        fetchLeaves(""); // only count on load
    }, []);

    // ✅ VIEW MODAL
    const handleView = (item) => {
        setSelectedItem(item);

        if (item.leaveCode === "AR") setModalType("AR");
        else if (item.leaveCode === "OD") setModalType("OD");
        else setModalType("LEAVE");
    };

    // ✅ FETCH LEAVES + COUNT
    const fetchLeaves = async (type = "") => {
        try {
            const formData = new FormData();
            formData.append("Type", "LeaveStatus");
            formData.append("EmployeeCode", employeeCode);

            if (statusFilter)
                formData.append("Status", statusFilter);

            const response = await LeaveProcessService.getEmployeeLeaveStatus(formData);

            if (response?.data?.statusCode === 200) {

                let data = response.data.result || [];

                // ✅ COUNT
                const ar = data.filter(x => x.leaveCode === "AR");
                const od = data.filter(x => x.leaveCode === "OD");
                const leave = data.filter(x => x.leaveCode !== "AR" && x.leaveCode !== "OD");

                setArCount(ar.length);
                setOdCount(od.length);
                setLeaveCount(leave.length);

                // ❌ NO DATA LOAD ON INITIAL
                if (!type) {
                    setLeaves([]);
                    return;
                }

                // ✅ TAB FILTER
                if (type === "AR") data = ar;
                else if (type === "OD") data = od;
                else if (type === "LEAVE") data = leave;

                setLeaves(data);

            } else {
                setLeaves([]);
            }

        } catch (error) {
            console.error("API Error:", error);
            setLeaves([]);
        }
    };

    // ✅ TAB CLICK
    const handleTabClick = (type) => {
        setActiveTab(type);
        fetchLeaves(type);
    };

    // ✅ FILTER
    const handleFilter = () => {
        fetchLeaves(activeTab);
    };

    // ✅ UNDO
    const handleUndo = async (leaveAppID, leaveTypeID) => {

        if (!window.confirm("Are you sure you want to Undo this leave?"))
            return;

        try {
            setLoading(true);

            const formData = new FormData();
            formData.append("Type", "UNDO");
            formData.append("LeaveAppID", leaveAppID);
            formData.append("LeaveTypeID", leaveTypeID);
            formData.append("EmployeeCode", employeeCode);

            const response = await LeaveProcessService.getEmployeeLeaveStatus(formData);

            if (response?.data?.statusCode === 200) {
                alert("Leave cancelled successfully");
                fetchLeaves(activeTab); // refresh tab + count
            } else {
                const message = response.errorMessage || 'Submission failed. Please try again.';
                alert(message);
            }
        } catch (error) {
            const message = error?.message || 'Unexpected error occurred.';
            toast.error(message);
            console.error("Unhandled error:", message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="container mt-3">
                <h4 className="mb-3">Request Status</h4>
                {/* ✅ TABS */}
                <div className="mb-3 d-flex gap-2">
                    <button
                        className={`btn ${activeTab === "LEAVE" ? "btn-primary" : "btn-outline-primary"}`}
                        onClick={() => handleTabClick("LEAVE")}
                    >
                        Leave ({leaveCount})
                    </button>
                    <button
                        className={`btn ${activeTab === "AR" ? "btn-primary" : "btn-outline-primary"}`}
                        onClick={() => handleTabClick("AR")}
                    >
                        AR ({arCount})
                    </button>
                    <button
                        className={`btn ${activeTab === "OD" ? "btn-primary" : "btn-outline-primary"}`}
                        onClick={() => handleTabClick("OD")}
                    >
                        OD ({odCount})
                    </button>
                </div>

                {/* ✅ FILTER */}
                <div className="row mb-3">
                    <div className="col-md-6">
                        <select
                            className="form-select"
                            value={statusFilter}
                            onChange={(e) => setStatusFilter(e.target.value)}
                        >
                            <option value="">All Status</option>
                            <option value="Pending">Pending</option>
                            <option value="Approved">Approved</option>
                            <option value="Rejected">Rejected</option>
                        </select>
                    </div>

                    <div className="col-md-6">
                        <button className="btn btn-primary w-100" onClick={handleFilter}>
                            Filter
                        </button>
                    </div>

                </div>

                {/* ✅ TABLE */}
                <div className="card shadow-sm border-0">
                    <div className="card-body p-0">

                        <div style={{ maxHeight: "500px", overflowY: "auto" }}>

                            <table className="table table-hover align-middle text-center mb-0">

                                <thead className="table-dark"
                                    style={{ position: "sticky", top: 0, zIndex: 2 }}>
                                    <tr>
                                        <th>Leave Type</th>
                                        <th>From</th>
                                        <th>To</th>
                                        <th>Total Days</th>
                                        <th>Status</th>
                                        <th>Manager</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {loading ? (
                                        <tr>
                                            <td colSpan="7">Loading...</td>
                                        </tr>
                                    ) : activeTab === "" ? (
                                        <tr>
                                            <td colSpan="7">Please select a tab</td>
                                        </tr>
                                    ) : leaves.length > 0 ? (
                                        leaves.map((item) => (
                                            <tr key={item.leaveAppID}>

                                                <td>
                                                    <span className="badge bg-primary">
                                                        {item.leaveCode}
                                                    </span>
                                                </td>

                                                <td>{new Date(item.fromDate).toLocaleDateString()}</td>
                                                <td>{new Date(item.toDate).toLocaleDateString()}</td>

                                                <td className="fw-bold">{item.totalDays}</td>

                                                <td>
                                                    <span className={`badge ${item.status === "Approved"
                                                        ? "bg-success"
                                                        : item.status === "Rejected"
                                                            ? "bg-danger"
                                                            : "bg-warning text-dark"
                                                        }`}>
                                                        {item.status}
                                                    </span>
                                                </td>

                                                <td>
                                                    <small>
                                                        {item.managerName}<br />
                                                        ({item.managerCode})
                                                    </small>
                                                </td>

                                                <td>
                                                    <button
                                                        className="btn btn-sm btn-info me-2"
                                                        onClick={() => handleView(item)}
                                                    >
                                                        View
                                                    </button>

                                                    <button
                                                        className="btn btn-sm btn-danger"
                                                        // disabled={item.status !== "Pending"}
                                                        onClick={() => handleUndo(item.leaveAppID, item.leaveTypeID)}
                                                    >
                                                        Undo
                                                    </button>
                                                </td>

                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="7">No Data Found</td>
                                        </tr>
                                    )}
                                </tbody>

                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {/* ✅ MODALS */}
            <LeaveModal show={modalType === "LEAVE"} data={selectedItem} onClose={() => setModalType("")} isManager={false} />
            <ARModal show={modalType === "AR"} data={selectedItem} onClose={() => setModalType("")} isManager={false} />
            <ODModal show={modalType === "OD"} data={selectedItem} onClose={() => setModalType("")} isManager={false} />
        </>
    );
}